import { render, staticRenderFns } from "./preTest.vue?vue&type=template&id=e72e48d2&"
import script from "./preTest.vue?vue&type=script&lang=js&"
export * from "./preTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports